import {
	initiateTransactionDataFetching,
	initiateTransactionDataFetchingWithJustKeyId,
	initiateTransactionDataFetchingWithProxy,
} from '../../api/consumerDataPullSessionApi'
import { ReceiverResult } from '../../types'
import { decodeBase64State } from '../stateDecoder'

export const initiateFetchingFromState = async (
	queryParameters: any,
): Promise<ReceiverResult> => {
	if (queryParameters?.code && queryParameters?.state) {
		const decodedBase64State = decodeBase64State(queryParameters?.state)
		if (decodedBase64State != null) {
			try {
				const response = await initiateTransactionDataFetchingWithProxy(
					decodedBase64State.url,
					decodedBase64State.keyId,
					queryParameters.code,
				)
				return { success: true, applicantId: response.applicantId }
			} catch {
				return { success: false }
			}
		}

		try {
			const response = await initiateTransactionDataFetching(
				queryParameters.state,
				queryParameters.code,
			)
			return { success: true, applicantId: response.applicantId }
		} catch {
			return { success: false }
		}
	}
	return { success: false }
}

export const initiateFetchingFromKeyIdAndCode = async (
	queryParameters: any,
): Promise<ReceiverResult> => {
	console.info('Initiating fetching from key id')
	if (queryParameters?.code && queryParameters?.keyid) {
		const decodedBase64State = decodeBase64State(queryParameters?.keyid)
		if (decodedBase64State != null) {
			try {
				const response = await initiateTransactionDataFetchingWithProxy(
					decodedBase64State.url,
					decodedBase64State.keyId,
					queryParameters.code,
				)
				return { success: true, applicantId: response.applicantId }
			} catch {
				return { success: false }
			}
		}

		try {
			const response = await initiateTransactionDataFetching(
				queryParameters.keyid,
				queryParameters.code,
			)
			return { success: true, applicantId: response.applicantId }
		} catch {
			return { success: false }
		}
	}
	return { success: false }
}

export const initiateFetchingFromKeyId = async (
	queryParameters: any,
): Promise<ReceiverResult> => {
	console.info('Initiating fetching from key id')
	if (queryParameters?.keyid) {
		const decodedBase64State = decodeBase64State(queryParameters?.keyid)
		if (decodedBase64State != null) {
			try {
				const response = await initiateTransactionDataFetchingWithProxy(
					decodedBase64State.url,
					decodedBase64State.keyId,
					queryParameters.code,
				)
				return { success: true, applicantId: response.applicantId }
			} catch {
				return { success: false }
			}
		}

		try {
			const response = await initiateTransactionDataFetchingWithJustKeyId(
				//
				queryParameters.keyid,
			)
			return { success: true, applicantId: response.applicantId }
		} catch {
			return { success: false }
		}
	}
	return { success: false }
}
